import { API_URL } from "reduxFiles/api/baseApi";

export const uploadFile = async (file: File) => {
  const fd = new FormData();
  fd.append("files", file);

  const token = sessionStorage.getItem("accessToken");

  const res = await fetch(`${API_URL}/file/upload`, {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
    body: fd,
  });

  if (!res.ok) throw new Error("Upload failed");

  const data = await res.json();

  return data.files[0];
};
